module.exports = __webpack_public_path__ + "static/media/David_Silberman2008.8b6258e1.jpg";